// The `[audio-clock]` diagnostic lines (issue #4116): the audio clock watchdog
// (page_audio_context.ts), the Player's Web Audio path and the Now Playing element each log what
// they did as one console.log line in this format, which recordConsoleLog()
// (client/src/util/logging.ts) keeps in localStorage on the device, so the record of a silent play
// button reads as one story: `[audio-clock] <source>: <event> (<details>)`.

// The part of an audio context a line reports
export type AudioClockState = Pick<AudioContext, 'state' | 'currentTime'>;

// One line from `source`, with `context`'s state and clock first among the details when given
export function logAudioClock(source: string, event: string, context?: AudioClockState, ...details: string[]) {
  const parts = context
    ? [`state ${context.state}`, `currentTime ${context.currentTime.toFixed(3)}`, ...details]
    : details;
  const suffix = parts.length > 0 ? ` (${parts.join(', ')})` : '';
  console.log(`[audio-clock] ${source}: ${event}${suffix}`);
}
